import { useState } from "react";
import { CategoriasCadastroDto } from "src/pages/Privada/Estoque/Categorias/Cadastro/CategoriasCadastro.Dto";
import { CategoriaFiltrar } from "src/services/Estoque.Service";

export const ConsultarCategoria = () => {
  const [loading, setLoading] = useState(false);

  const CategoriaBuscar = (query: string): Promise<CategoriasCadastroDto[]> => {
    setLoading(true);
    return new Promise<CategoriasCadastroDto[]>((resolve, reject) => {
      CategoriaFiltrar({ id: 0, nome: query })
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            resolve(data);
          } else {
            if (response.status === 204) {
              resolve([]);
            } else {
              response.data.notifications.forEach((err: any) =>
                console.log(err.message)
              );
              reject("Erro ao buscar dados");
            }
          }
        })
        .catch((error) => {
          console.log(error);
          reject("Erro ao buscar dados");
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return {
    CategoriaBuscar,
    loading,
  };
};
